import React from 'react'

const DeleteIcon = () => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2341 17.5713C13.0673 17.5712 13.7858 16.8962 13.8379 16.0646L14.5477 4.71418H15.0834C15.3791 4.71418 15.6191 4.47418 15.6191 4.17847V3.64275C15.6191 3.34704 15.3791 3.10704 15.0834 3.10704H12.3245L11.1861 1.20859C10.9277 0.777969 10.3103 0.428467 9.80806 0.428467H6.43022C5.92799 0.428467 5.31063 0.777969 5.05219 1.20859L3.9138 3.10704H1.15485C0.85914 3.10704 0.619141 3.34704 0.619141 3.64275V4.17847C0.619141 4.47418 0.85914 4.71418 1.15485 4.71418H1.69057L2.4004 16.0646C2.45245 16.8962 3.17098 17.5712 4.00417 17.5713H12.2341ZM10.4495 3.10704H5.7888L6.43163 2.03561H9.80665L10.4495 3.10704ZM4.00453 15.9642H12.2341L12.9376 4.71418H3.30141L4.00453 15.9642Z"
      fill="#2C2C2C"
    />
  </svg>
)

export { DeleteIcon }
